import { createSelector } from 'reselect'
import { selectCurrentUserPrefersAutoloadFirstTicketInList } from './selectCurrentUserPrefersAutoloadFirstTicketInList'
import { selectPrefersClassicView } from './selectPrefersClassicView'

export const selectAutoLoadFirstTicketInList = createSelector(
  selectPrefersClassicView,
  selectCurrentUserPrefersAutoloadFirstTicketInList,
  (classicView, autoload) => !classicView && autoload
)
